import { render, staticRenderFns } from "./realManageAdmin.vue?vue&type=template&id=6a379d70"
import script from "./realManageAdmin.vue?vue&type=script&lang=js"
export * from "./realManageAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports